module.exports = new __parcel__URL__("statuspage-left.6c5cd6d4.svg").toString();